import React from 'react';
import { mergeStyleSets, FontSizes, FontWeights, } from '@fluentui/react';


const classNames = mergeStyleSets({
  stepTitle: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.medium,
    selectors: {
      '& ~ *': {
        marginTop: '6px',
      }
    }
  },
});


export function Step({ title, children }) {
  return (
    <div>
      <span className={classNames.stepTitle}>{ title }</span>
      { children }
    </div>
  );
}


export const getStepTitleGenerator = () => {
  let actionCounter = 0;
  return (title) => `${++actionCounter}. ${title}`;
}


export default Step;
